/*
  Recently viewed (sections/recently-viewed.liquid, on the product page).

  The list is the live theme's own: localStorage "recently-viewed", product handles, newest
  first, comma-separated, at most 10. Keeping its key and format means a shopper's history
  carries over from the current site. A piece seen again moves to the front.

  The row shows the pieces seen before this one. Each card is the site's own product card,
  fetched through the Section Rendering API (sections/recently-viewed-card.liquid) only once
  the shopper nears the row, so it never competes with the product photos. A piece that no
  longer exists leaves the list. With nothing to show, the row stays hidden.
*/
(() => {
  const KEY = 'recently-viewed';
  const MAX = 10;
  const box = document.querySelector('[data-recently-viewed]');
  if (!box || box.dataset.ready) return;
  box.dataset.ready = 'true';

  const read = () => {
    try {
      return (localStorage.getItem(KEY) || '').split(',').map((handle) => handle.trim()).filter(Boolean);
    } catch (error) {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, [...new Set(list)].slice(0, MAX).join(','));
    } catch (error) { /* storage blocked: the row simply stays empty */ }
  };

  const current = box.dataset.handle || '';
  const earlier = read().filter((handle) => handle !== current);
  if (current && box.dataset.skip !== 'true') write([current, ...earlier]);

  const limit = Number(box.dataset.limit) || 8;
  // A couple more than shown, in case some no longer exist
  const handles = earlier.slice(0, limit + 2);
  const target = box.querySelector('[data-recently-viewed-target]');
  if (!handles.length || !target || !window.fetch) return;

  const root = window.Shopify?.routes?.root || '/';
  const cardFor = async (handle) => {
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=recently-viewed-card`);
      if (response.status === 404) return { handle, gone: true };
      if (!response.ok) return { handle };
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const item = doc.querySelector('.pdp-related__item');
      // Shopify answers a product that no longer exists with an empty section, not a 404
      return item ? { handle, item } : { handle, gone: true };
    } catch (error) {
      return { handle };
    }
  };

  const load = async () => {
    const results = await Promise.all(handles.map(cardFor));
    const gone = results.filter((result) => result.gone).map((result) => result.handle);
    if (gone.length) write(read().filter((handle) => !gone.includes(handle)));
    const items = results.map((result) => result.item).filter(Boolean).slice(0, limit);
    if (!items.length) return;
    items.forEach((item) => {
      const cell = document.createElement('div');
      cell.className = 'pdp-cross__item';
      cell.innerHTML = item.innerHTML;
      target.append(cell);
    });
    box.hidden = false;
  };

  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    load();
  };
  // As the shopper nears the row; a few seconds after load as a backstop.
  if ('IntersectionObserver' in window) {
    const watch = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      watch.disconnect();
      start();
    }, { rootMargin: '0px 0px 60% 0px' });
    // The row is hidden (no box) until filled: watch the end of the product's details, the
    // point the "More from …" row also loads at.
    const anchor = document.querySelector('[data-pdp-related-sentinel]') || document.querySelector('.pdp__details');
    if (anchor) watch.observe(anchor);
    else start();
  } else {
    start();
  }
  window.addEventListener('load', () => window.setTimeout(start, 4000));
})();
